import React from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './FedbackIcons.module.scss';
const FeedbackPositive = ({
  onClick
}) => /*#__PURE__*/React.createElement(Icon, {
  onClick: onClick,
  name: "thumbUp",
  classname: styles.root
});
export default FeedbackPositive;